import { isTequilaSelector } from "@kiwicom/frontend-common/services/options/selectors"
import React from "react"
import { createRoot } from "react-dom/client"
import { Provider } from "react-redux"
// @ts-expect-error: Flow to TS migration.
import { Router } from "react-router-dom"
// @ts-expect-error: Flow to TS migration.
import { matchRoutes, renderRoutes } from "react-router-config"
import browserHistory from "@kiwicom/frontend-common/browser/history"
import session from "@kiwicom/frontend-common/browser/session"
import NitroProvider from "@kiwicom/frontend-common/components/NitroProvider"
import { getTranslations } from "@kiwicom/frontend-common/services/intl"
import { getLanguageInfo } from "@kiwicom/frontend-common/services/staticData"
import fetchAsyncLoads from "@kiwicom/frontend-common/utils/fetchAsyncLoads"
import commonPreRender from "@kiwicom/frontend-common/browser/commonPreRender"
import commonPostRender from "@kiwicom/frontend-common/browser/commonPostRender"
import Modals from "@kiwicom/frontend-common/components/Modals/Modals"
import cuckoo from "@kiwicom/frontend-common/services/cuckoo/cuckoo"
import { cuckooEvents } from "@kiwicom/frontend-common/consts/enums"
import { DarwinProvider } from "@kiwicom/darwin"
import logTestStart from "@kiwicom/nitro/lib/services/darwin/logTestStart"
import { IntlProvider } from "react-intl"

import getRoutes from "../router/getRouter"
import postRender from "./postRender"
import store from "./store"
import { ToastRoot } from "@kiwicom/orbit-components/lib/Toast"
import ReactQueryProvider from "../scenes/AccountBooking/components/Booking/services/reactQuery/ReactQueryProvider"

// @ts-expect-error: Flow to TS migration.
const routes = getRoutes(window.SP_GLOBALS.SKYPICKER_LNG)

const renderIntoId = (app: React.ReactElement, elementId: string) => {
  const node = document.getElementById(elementId)

  if (!node) return

  const root = createRoot(node)

  root.render(app)
}

// Actual render
// ---
// Fix this the next time the file is edited. (Flow to TS)
// eslint-disable-next-line @typescript-eslint/no-floating-promises
;(async () => {
  try {
    commonPreRender(store)

    const routeMatch = matchRoutes(routes, `${window.location.pathname}${window.location.search}`)
    // @ts-expect-error: Flow to TS migration.
    const components = routeMatch.map((r) => r.route.component)

    await fetchAsyncLoads(components)

    const state = store.getState()

    const intl = {
      language: getLanguageInfo(state),
      translations: getTranslations(state),
    } as const

    const isTequila = isTequilaSelector(state)

    const endpoint = isTequila ? "tequila" : "plexus"

    // @ts-expect-error: Flow to TS migration.
    const { tests, features, winners } = window.__DARWIN__

    const AppRoot = () => (
      // @ts-expect-error: Flow to TS migration.
      <Provider store={store}>
        <ReactQueryProvider>
          <DarwinProvider tests={tests} features={features} winners={winners} onTest={logTestStart}>
            <IntlProvider
              // @ts-expect-error: Flow to TS migration.
              {...window.__INTL_ICU__}
              defaultRichTextElements={{
                br: () => <br />,
                em: (text) => <em>{text}</em>,
                p: (text) => <p>{text}</p>,
                span: (text) => <span>{text}</span>,
                strong: (text) => <strong>{text}</strong>,
                i: (text) => <i>{text}</i>,
              }}
            >
              <NitroProvider
                intl={intl}
                // @ts-expect-error: Flow to TS migration.
                brand={window.__BRAND__}
                // @ts-expect-error: Flow to TS migration.
                endpoint={endpoint}
                session={session}
                onLogout={() => {
                  // Fix this the next time the file is edited. (Flow to TS)
                  // eslint-disable-next-line @typescript-eslint/restrict-template-expressions
                  window.location.href = `/${intl.language.id}/user/login`
                }}
              >
                <ToastRoot />
                <Router history={browserHistory}>{renderRoutes(routes)}</Router>
              </NitroProvider>
            </IntlProvider>
          </DarwinProvider>
        </ReactQueryProvider>
      </Provider>
    )

    renderIntoId(<AppRoot />, "react-view")

    // Modals
    // ---

    const ModalsRoot = () => (
      // @ts-expect-error: React upgrade
      <Provider store={store}>
        <Modals />
      </Provider>
    )

    renderIntoId(<ModalsRoot />, "modals")

    postRender(store)
    commonPostRender()
    // Fix this the next time the file is edited. (Flow to TS)
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
  } catch (error: any) {
    // TODO: Add winston logging for error tracking (Datadog integration)
    // eslint-disable-next-line no-console
    console.error("General render error", { error })
    cuckoo.track(cuckooEvents.GENERAL_RENDER_ERROR, { error })
  }
})()
